import { Redline } from 'redline-client-sdk';
import { RLCapraEvents } from '../types';
import { pixel } from './pixel';

export const capraEvents = (rl: Redline): RLCapraEvents => ({
  appTracked: (payload = {}) => {
    const event = 'capra.AppTracked.v1';
    rl.track(event, payload);
    pixel(event, payload);
  },
});
